import { Link } from 'gatsby';
import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSolid, faListUl, faBars } from '@fortawesome/free-solid-svg-icons';
import { GridMobilStyle } from '../styles/GridMobilStyle';

import HomeMobil from './HomeMobil';
import ListMobil from './ListMobil';
import ContentPageMobil from './ContentPageMobil';
import NavMobil from './NavMobil';

export default function GridMobil({ pageContent, location }) {
  const urlPath = pageContent.props.uri;

  const checkPagesList =
    urlPath === '/realisations' ||
    urlPath === '/etudes' ||
    urlPath === '/actualites' ||
    urlPath === '/contact' || 
    urlPath === '/colophon' ||
    urlPath === '/cv' ||
    urlPath === '/biographie';

  return (
    <GridMobilStyle>
      <NavMobil />
      {location.pathname === '/' && <HomeMobil />}

      {checkPagesList && <ListMobil pageContent={pageContent} />}
      {!pageContent.props.custom404 &&
        location.pathname !== '/' &&
        !checkPagesList && (
          <ContentPageMobil pageContent={pageContent} location={location} />
        )}

      {pageContent.props.custom404 && <p>error</p>}
    </GridMobilStyle>
  );
}
